'use client';

import type { ListCollection } from '@ark-ui/react';
import { ArrowUpDownIcon, Tick01Icon } from '@terra/ui-icons';
import { Field } from '../../../components/field';
import { Select } from '../../../components/select';
import type { ExternalNetworkSettingsSelectItem } from './external-settings.model';

export type ExternalNetworkSettingsSelectFieldProps = {
  label: string;
  collection: ListCollection<ExternalNetworkSettingsSelectItem>;
  value: string;
  onValueChange: (value: string) => void;
};

export function ExternalNetworkSettingsSelectField({
  label,
  collection,
  value,
  onValueChange,
}: ExternalNetworkSettingsSelectFieldProps) {
  return (
    <Field.Root>
      <Field.Label>{label}</Field.Label>
      <Select.Root
        positioning={{ sameWidth: true }}
        width="full"
        collection={collection}
        value={[value]}
        onValueChange={(event) => {
          const nextValue = event.value[0];

          if (nextValue) {
            onValueChange(nextValue);
          }
        }}
      >
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText />
            <ArrowUpDownIcon size={14} />
          </Select.Trigger>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            <Select.ItemGroup>
              {collection.items.map((item) => (
                <Select.Item key={item.value} item={item}>
                  <Select.ItemText>{item.label}</Select.ItemText>
                  <Select.ItemIndicator>
                    <Tick01Icon size={14} />
                  </Select.ItemIndicator>
                </Select.Item>
              ))}
            </Select.ItemGroup>
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </Field.Root>
  );
}
